import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Sloution.css'; // Correction de la faute "Sloution" en "Solutions"
import Header from './Header';
import { FaTachometerAlt, FaBuilding, FaOilCan, FaBolt, FaWifi, FaLaptopCode } from 'react-icons/fa';

function Solutions() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeCard, setActiveCard] = useState(null); // Suivre la carte active

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const solutions = [
    {
      id: 1,
      title: 'Analyse Vibratoire',
      icon: <FaTachometerAlt size={40} />,
      shortDescription: 'Surveillez en temps réel l’état de vos machines pour une maintenance proactive.',
      link: '/solutions/analyse-vibratoire',
    },
    {
      id: 2,
      title: 'Gestion intelligente des bâtiments',
      icon: <FaBuilding size={40} />,
      shortDescription: 'Optimisez la gestion énergétique et la sécurité de vos infrastructures.',
      image: '/src/Assets/developpement-logiciel.jpg',
      link: '/solutions/gestion',
    },
    {
      id: 3,
      title: 'Gestion de la lubrification ',
      icon: <FaOilCan size={40} />,
      shortDescription: 'Améliorez la durée de vie de vos équipements grâce à une lubrification efficace.',
      image: '/src/Assets/cybersecurite.jpg',
      link: '/solutions/gestion-lubrification',
    },
    {
      id: 4,
      title: 'Electricité industrielle & automatisme',
      icon: <FaBolt size={40} />,
      shortDescription: 'Automatisez vos processus industriels pour une production optimisée.',
      image: '/src/Assets/analyse-donnees.jpg',
      link: '/solutions/Industry&auto',
    },
    {
      id: 5,
      title: 'Wireless Monitoring system',
      icon: <FaWifi size={40} />,
      shortDescription: 'Surveillez vos équipements à distance avec une solution sans fil.',
      image: '/src/Assets/gestion-bdd.jpg',
      link: '/solutions/Monitoring',
    },
    {
      id: 6,
      title: 'Software',
      icon: <FaLaptopCode size={40} />,
      shortDescription: 'Développez des logiciels sur mesure pour vos besoins spécifiques.',
      image: '/src/Assets/solutions-reseaux.jpg',
      link: '/solutions/software',
    },
  ];

  const handleCardClick = (id) => {
    setActiveCard(activeCard === id ? null : id); // Basculer l'état actif
  };

  return (
    <div className="solutions-wrapper">
      <Header isScrolled={isScrolled} />
      <div className="solutions-container">
        <div className="image">
          <div className="image-text">
            <h1 style={{ fontFamily: "'Poppins', sans-serif", fontWeight: '400' }}>
              Nos Solutions
            </h1>
            <p style={{ fontFamily: "'Poppins', sans-serif", fontWeight: '100' }}>
              Découvrez nos solutions innovantes adaptées à vos besoins.<br />
              Nous transformons vos idées en réalité.
            </p>
          </div>
        </div>
        <div className="content">
          <h2>Nos Offres</h2>
          <p>
            Nous proposons une gamme de solutions technologiques pour optimiser vos processus et stimuler l’innovation dans votre entreprise.
          </p>
          <div className="solutions-grid">
            {solutions.map((solution) => (
              <Link
                key={solution.id}
                to={solution.link}
                className={`solution-card ${activeCard === solution.id ? 'active' : ''}`}
                onClick={() => handleCardClick(solution.id)}
              >
                <div className="solution-icon">{solution.icon}</div>
                <h3>{solution.title}</h3>
                <p className="solution-description">{solution.shortDescription}</p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Solutions;